import { useEffect, useLayoutEffect, useRef } from "react";
import SoundMeter from "./helpers/soundmeter";

function AudioMeter(props) {
  const stream = props.stream;

  const instantMeter = useRef(null);
  const instantValueDisplay = useRef(null);

  const slowMeter = useRef(null);
  const slowValueDisplay = useRef(null);

  useLayoutEffect(() => {
    if (!stream) return;

    let refreshInterval = null;
    let audioContext = new window.AudioContext();
    const soundMeter = new SoundMeter(audioContext);
    soundMeter.connectToSource(stream, function(e) {
      refreshInterval = setInterval(() => {
        instantMeter.current.value = soundMeter.instant.toFixed(2);
        // instantMeter.current.innerText = instantMeter.current.value;
      }, 200);
    });

    return () => {
      if (refreshInterval) {
        clearInterval(refreshInterval);
      }
      if (audioContext) {
        audioContext.close();
      }
      if (soundMeter) {
        soundMeter.stop();
      }
    };
  }, [stream]);

  return (
    <div className="flex items-center space-x-2">
      <div>Microphone:</div>
      <meter ref={instantMeter} high="0.25" max="0.60" value="0"></meter>
      {/* <div ref={instantValueDisplay}></div> */}
    </div>
  );
}

export default AudioMeter;
